// extracted by mini-css-extract-plugin
export default {"dialog":"AccessibleDialog_dialog__smAG0","closeButton":"AccessibleDialog_closeButton__u4SEy"};